import Box from '@mui/material/Box/Box';
import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography/Typography';

import { colors, devices } from 'styles';

export const ContactFormWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCTABlock',
})<{ isCTABlock?: boolean }>`
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: ${(props) => (props.isCTABlock ? colors.textPrimary : colors.blue)};
`;

export const ThanksText = styled('p')`
  margin: 0 auto;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
`;

export const ContactFormText = styled('p', {
  shouldForwardProp: (prop) => prop !== 'isCTABlock',
})<{ isCTABlock?: boolean }>`
  line-height: 22px;
  font-weight: 700;
  line-height: 120%;
  margin-top: 0;
  text-align: center;
  font-size: ${(props) => (props.isCTABlock ? '32px' : '40px')};
  width: 100%;
  margin: 0;

  @media (${devices.xs}) {
    max-width: 540px;
  }

  @media (${devices.sm}) {
    max-width: 764px;
    font-size: ${(props) => (props.isCTABlock ? '32px' : '36px')};
  }

  @media (${devices.lg}) {
    font-size: ${(props) => (props.isCTABlock ? '40px' : '48px')};
  }
`;

export const ContactFormDescription = styled('p')`
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0px;
  text-align: center;
  width: 100%;
  max-width: 343px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 24px;
  margin-bottom: 0;
  white-space: pre-line;

  @media (${devices.xs}) {
    max-width: 540px;
  }

  @media (${devices.sm}) {
    max-width: 768px;
  }
`;

export const WebWrapper = styled(Box)`
  position: absolute;

  img {
    width: 100%;
    max-width: 300px;
    height: 100%;
    display: block;

    @media (${devices.sm}) {
      max-width: 400px;
    }
  }
`;

export const ContactFormButtonsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'naturalOrder',
})<{ naturalOrder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ naturalOrder }) => (naturalOrder ? 'column' : 'column-reverse')};
  gap: 16px;

  @media (${devices.sm}) {
    flex-direction: ${({ naturalOrder }) => (naturalOrder ? 'row' : 'row-reverse')};
  }
`;

export const ContactFormFooterLink = styled('a')`
  margin-top: 32px;
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  color: ${colors.white};
  font-size: 14px;
  line-height: 150%;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: opacity 0.15s ease;

  @media (${devices.sm}) {
    align-items: center;
  }

  &:hover,
  &:focus-visible {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${colors.white};
    outline-offset: 4px;
    border-radius: 2px;
  }

  & strong {
    font-weight: 700;
  }

  & .MuiSvgIcon-root {
    font-size: 18px;
    flex-shrink: 0;
  }
`;

export const ContactFormFooterLinkMobileBreak = styled('br')`
  display: inline;

  @media (${devices.sm}) {
    display: none;
  }
`;

export const InformationField = styled(Typography)`
  font-size: 12px;
  line-height: 150%;
  color: ${colors.white};
  text-align: center;
  position: relative;
  z-index: 2;
`;
